/* src/app/core/pages/forgot-password/forgot-password.component.scss */
.main-container ::ng-deep .p-inputtext {
  font-size: 0.8rem;
  padding: 0.65rem;
  width: 100%;
}
.main-container ::ng-deep .p-button {
  font-size: 0.85rem;
  font-weight: 500;
}
/*# sourceMappingURL=forgot-password.component.css.map */
